import { Injectable } from '@angular/core';
import { IDynamicKeyValue, INameId } from '@modeso/types__aumico-lib-core-be';
import { ComponentType, ComponentsOptionsDTO, INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { NotesTypeFieldsName } from '../enums/notesTypeFieldsName.enum';

@Injectable({
    providedIn: 'root',
})
export class NotesTypesHelper {
    constructor() {}

    getNotesTypeFormValues(
        formValues,
        componentsOptions: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>,
    ): INotesTypeEntityDTO {
        const selectedNotesComponent: ComponentType[] = formValues[NotesTypeFieldsName.NOTES_COMPONENTS].map(
            (selectedNoteComponent: INameId) => selectedNoteComponent.name,
        );
        const notesType: INotesTypeEntityDTO = {
            name: formValues[NotesTypeFieldsName.NAME],
            title: this.getTitleOrInformationObjectFromForm(formValues, NotesTypeFieldsName.TITLE),
            componentsOptions: this.getComponentsOptions(selectedNotesComponent, componentsOptions),
            information: this.getTitleOrInformationObjectFromForm(formValues, NotesTypeFieldsName.INFORMATION),
        };

        return notesType;
    }

    getComponentOptions(
        componentOptions: ComponentsOptionsDTO[],
    ): Map<string, Omit<ComponentsOptionsDTO, 'componentName'>> {
        const componentOptionsData: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>> = new Map<
            string,
            Omit<ComponentsOptionsDTO, 'componentName'>
        >();

        componentOptions.forEach((option: ComponentsOptionsDTO) => {
            const { componentOptions, componentId } = option;
            componentOptionsData.set(option.componentName, { componentOptions, componentId });
        });

        return componentOptionsData;
    }

    getIdsAndNamesOfNotesTypes(notesTypes: INotesTypeEntityDTO[]): INameId[] {
        const idsAndNamesOfNotesTypes: INameId[] = [];

        notesTypes.forEach((notesType: INotesTypeEntityDTO) => {
            idsAndNamesOfNotesTypes.push({ id: notesType._id, name: notesType.name });
        });

        return idsAndNamesOfNotesTypes;
    }

    getArrayOfINameIds(arrayToBeConverted: string[]): INameId[] {
        return Object.keys(arrayToBeConverted).map((key) => {
            return { id: key, name: arrayToBeConverted[key] } as INameId;
        });
    }

    private getComponentsOptions(
        selectedComponents: string[],
        componentsOptions: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>,
    ): ComponentsOptionsDTO[] {
        const components: string[] = Array.from(componentsOptions.keys());
        const componentOptionsOfSelectedComponents: ComponentsOptionsDTO[] = [];
        for (const component of components) {
            if (selectedComponents.indexOf(component) !== -1) {
                const options: ComponentsOptionsDTO = {
                    componentName: component as ComponentType,
                    componentId: componentsOptions.get(component).componentId,
                    componentOptions: componentsOptions.get(component).componentOptions,
                };

                componentOptionsOfSelectedComponents.push(options);
            }
        }

        return componentOptionsOfSelectedComponents;
    }

    private getTitleOrInformationObjectFromForm(formValue, keyName: string): IDynamicKeyValue {
        const information: IDynamicKeyValue = {};
        for (const key in formValue) {
            if (key.includes(keyName)) {
                const language = key.split(`${keyName}-`)[1];
                information[language] = formValue[key];
            }
        }

        return information;
    }
}
